var map = {
	"./LaserParticle_1.json": [
		533,
		47
	],
	"./LaserParticle_2.json": [
		534,
		48
	],
	"./LaserParticle_3.json": [
		535,
		49
	],
	"./LaserParticle_4.json": [
		536,
		50
	],
	"./LaserParticle_5.json": [
		537,
		51
	],
	"./LaserParticle_6.json": [
		538,
		52
	],
	"./LaserParticle_7.json": [
		539,
		53
	],
	"./Laser_1.json": [
		540,
		54
	],
	"./Laser_2.json": [
		541,
		55
	],
	"./Laser_3.json": [
		542,
		56
	],
	"./Laser_4.json": [
		543,
		57
	],
	"./Laser_5.json": [
		544,
		58
	],
	"./Laser_6.json": [
		545,
		59
	],
	"./Laser_7.json": [
		546,
		60
	],
	"./Laser_8.json": [
		547,
		61
	],
	"./Laser_9.json": [
		548,
		62
	],
	"./Smoke.json": [
		549,
		63
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1075;
module.exports = webpackAsyncContext;